var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { getBlockParentPage, getTextContent } from '@simpledotink/notion-utils';
import { useLocalStorage, useWindowSize } from 'react-use';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import { CollectionViewIcon } from '../icons/collection-view-icon';
import { ChevronDownIcon } from '../icons/chevron-down-icon';
import { CollectionView } from './collection-view';
import { PageIcon } from './page-icon';
import { useNotionContext } from '../context';
import { cs } from '../utils';
import SvgCollectionViewGallery from '../icons/collection-view-gallery';
import SvgCollectionViewList from '../icons/collection-view-list';
import SvgCollectionViewCalendar from '../icons/collection-view-calendar';
import SvgCollectionViewTimeline from '../icons/collection-view-timeline';
import SvgCollectionViewBoard from '../icons/collection-view-board';
import SvgCollectionViewTable from '../icons/collection-view-table';
import { UseRetrieveBlocks } from '../hooks/useRetrieveBlocks';
import { useCollection } from '../hooks/useCollection';
var isServer = typeof window === 'undefined';
var triggers = ['click'];
export var Collection = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var block = _a.block, className = _a.className;
    var _o = useNotionContext(), recordMap = _o.recordMap, showCollectionViewDropdown = _o.showCollectionViewDropdown;
    var _p = UseRetrieveBlocks(), retrieveMissingBlocks = _p.retrieveMissingBlocks, retrieveMissingCollections = _p.retrieveMissingCollections;
    var retrieveCollectionId = useCollection().retrieveCollectionId;
    var viewIds = block.view_ids;
    var collectionId = retrieveCollectionId(block);
    //   recordMap.collection_view[viewIds[0]]?.value?.format?.collection_pointer
    //     ?.id || block?.format?.collection_pointer?.id
    var _q = useLocalStorage(block.id, {
        collectionViewId: viewIds[0]
    }), collectionState = _q[0], setCollectionState = _q[1];
    var collectionViewId = viewIds.find(function (id) { return id === collectionState.collectionViewId; }) || viewIds[0];
    // if (!collectionId) {
    //   // find the
    //   const views = Object.entries(recordMap?.block || {})
    //     ?.filter((entry) => {
    //       return entry[1]?.value?.type == 'collection_view'
    //     })
    //     .map((entry) => entry[1].value)
    //   collectionId = (
    //     views.find(
    //       (b: any) => b.created_by_id == block.created_by_id && b.collection_id
    //     ) as any
    //   )?.collection_id
    // }
    var onChangeView = React.useCallback(function (_a) {
        var collectionViewId = _a.key;
        setCollectionState(__assign(__assign({}, collectionState), { collectionViewId: collectionViewId }));
    }, [collectionState, setCollectionState]);
    var width = useWindowSize().width;
    if (isServer) {
        width = 1024;
    }
    // TODO: customize for mobile?
    var maxNotionBodyWidth = 708;
    var notionBodyWidth = maxNotionBodyWidth;
    var parentPage = getBlockParentPage(block, recordMap);
    if ((_b = parentPage === null || parentPage === void 0 ? void 0 : parentPage.format) === null || _b === void 0 ? void 0 : _b.page_full_width) {
        notionBodyWidth = (width - 2 * Math.min(96, width * 0.08)) | 0;
    }
    else {
        notionBodyWidth =
            width < maxNotionBodyWidth
                ? (width - width * 0.02) | 0 // 2vw
                : maxNotionBodyWidth;
    }
    var padding = isServer ? 96 : ((width - notionBodyWidth) / 2) | 0;
    // console.log({ width, notionBodyWidth, padding })
    var collection = (_d = (_c = recordMap.collection) === null || _c === void 0 ? void 0 : _c[collectionId]) === null || _d === void 0 ? void 0 : _d.value;
    var collectionView = (_f = (_e = recordMap.collection_view) === null || _e === void 0 ? void 0 : _e[collectionViewId]) === null || _f === void 0 ? void 0 : _f.value;
    var collectionData = (_h = (_g = recordMap.collection_query) === null || _g === void 0 ? void 0 : _g[collectionId]) === null || _h === void 0 ? void 0 : _h[collectionViewId];
    var filteredCollectionIds = recordMap['filtered_collection_ids'];
    if (!(collection && collectionView) && collectionId && collectionViewId) {
        retrieveMissingBlocks([
            { id: collectionId, table: 'collection' },
            { id: collectionViewId, table: 'collection_view' }
        ]);
        return null;
    }
    else if (!collectionData && collectionId) {
        var filters = (_j = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _j === void 0 ? void 0 : _j.property_filters;
        var reducers = __assign({ reducers: {
                collection_group_results: {
                    type: 'results',
                    limit: 9999,
                    loadContentCover: false
                }
            } }, (filters ? { filters: filters } : null));
        retrieveMissingCollections(collectionId, collectionViewId, reducers);
        return null;
    }
    var style = {};
    if ((collectionView === null || collectionView === void 0 ? void 0 : collectionView.type) === 'table' || (collectionView === null || collectionView === void 0 ? void 0 : collectionView.type) === 'board') {
        // style.paddingLeft = padding
        // style.paddingRight = padding
    }
    var title = getTextContent(collection === null || collection === void 0 ? void 0 : collection.name).trim();
    title = ((_k = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _k === void 0 ? void 0 : _k.hide_linked_collection_name) ? null : title;
    var headerData = generateCollectionHeader(collectionView);
    if (collection === null || collection === void 0 ? void 0 : collection.icon) {
        block.format = __assign(__assign({}, block.format), { page_icon: collection.icon });
    }
    var isCollectionViewPage = (block === null || block === void 0 ? void 0 : block.type) === 'collection_view_page';
    // if the view does not have a name field, we assume notion does not want it
    // to be shown. That's the only way  to identify hidden views from visible
    // views.
    viewIds = viewIds
        .map(function (id) { var _a; return (_a = recordMap.collection_view[id]) === null || _a === void 0 ? void 0 : _a.value; })
        .filter(function (b) { return typeof (b === null || b === void 0 ? void 0 : b.name) == 'string' || (!(b === null || b === void 0 ? void 0 : b.name) && (b === null || b === void 0 ? void 0 : b.type) != 'table'); })
        .map(function (b) { return b === null || b === void 0 ? void 0 : b.id; });
    var resultsGroups = Object.entries(collectionData || {})
        .filter(function (entry) { var _a; return entry && entry[1].type == 'results' && ((_a = entry[1].blockIds) === null || _a === void 0 ? void 0 : _a.length) == 0; })
        .map(function (ent) { return ent[0]; }) || [];
    var groups = ((_l = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _l === void 0 ? void 0 : _l.collection_groups) || [];
    if (((_m = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _m === void 0 ? void 0 : _m.collection_groups) &&
        collectionData.gallery_groups &&
        resultsGroups.length > 0 &&
        groups.length > 0) {
        // we are going to construct a default query for this kind of collectiondata
        // console.log(groups, resultsGroups)
        var filters = (collectionView.format.property_filters || []).map(function (_a) {
            var filter = _a.filter;
            return filter;
        });
        var loaders_1 = {
            type: 'reducer',
            reducers: {}
        };
        if (filters.length > 0)
            loaders_1.filter = { filters: filters, operator: 'and' };
        groups.forEach(function (group, i) {
            var _a, _b;
            var filters = [];
            if (group.value.type == 'date' && ((_b = (_a = group.value) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.range)) {
                filters.push({
                    property: group.property,
                    filter: {
                        operator: 'date_is_within',
                        value: {
                            type: 'exact',
                            value: group.value.value.range
                        }
                    }
                });
                loaders_1.reducers[resultsGroups[i]] = {
                    type: 'results',
                    filter: { filters: filters, operator: 'and' },
                    limit: 25,
                    loadContentCover: false
                };
            }
        });
        retrieveMissingCollections(collectionId, collectionViewId, loaders_1);
    }
    return (React.createElement("div", { className: cs('notion-collection', className) },
        React.createElement("div", { className: 'notion-collection-header', style: style },
            viewIds.length == 1 && (React.createElement("div", { className: cs(collectionState.collectionViewId === viewIds[0]
                    ? 'notion-collection-view-type-wrapper-selected'
                    : '', 'notion-collection-view-type-wrapper-single') },
                headerData.icon,
                React.createElement("span", { className: 'notion-collection-header' }, headerData.name))),
            viewIds.length > 1 && showCollectionViewDropdown && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'notion-collection-header hide-on-mobile' }, viewIds.map(function (viewId) {
                    var _a;
                    return (React.createElement("div", { onClick: function () { return onChangeView({ key: viewId }); }, key: viewId, className: cs(collectionState.collectionViewId === viewId
                            ? 'notion-collection-view-type-wrapper-selected'
                            : '', 'notion-collection-view-type-wrapper') },
                        React.createElement(CollectionViewColumnDesc, { collectionView: (_a = recordMap.collection_view[viewId]) === null || _a === void 0 ? void 0 : _a.value })));
                })),
                React.createElement("div", { className: 'hide-on-desktop' },
                    React.createElement(Dropdown, { trigger: triggers, overlay: React.createElement(Menu, { onSelect: onChangeView }, viewIds.map(function (viewId) {
                            var _a;
                            return (React.createElement(MenuItem, { key: viewId, className: 'notion-collection-view-type-menu-item' },
                                React.createElement(CollectionViewColumnDesc, { collectionView: (_a = recordMap.collection_view[viewId]) === null || _a === void 0 ? void 0 : _a.value })));
                        })), animation: 'slide-up' },
                        React.createElement(CollectionViewColumnDesc, { className: 'notion-collection-view-dropdown', collectionView: collectionView },
                            React.createElement(ChevronDownIcon, { className: 'notion-collection-view-dropdown-icon' }))))))),
        title && !isCollectionViewPage && (React.createElement("div", { className: 'notion-collection-header-title' },
            React.createElement(React.Fragment, null,
                React.createElement(PageIcon, { block: block, collection: collection, className: 'notion-page-title-icon', hideDefaultIcon: true }),
                title))),
        title && isCollectionViewPage && (collectionView === null || collectionView === void 0 ? void 0 : collectionView.type) != 'page' && (React.createElement("div", { className: 'notion-collection-header-title' },
            React.createElement("div", { style: { marginTop: '10px' } }, title))),
        React.createElement(CollectionView, { collection: collection, collectionView: collectionView, collectionData: collectionData, filteredCollectionIds: filteredCollectionIds, padding: padding, width: width })));
};
var CollectionViewColumnDesc = function (_a) {
    var collectionView = _a.collectionView, className = _a.className, children = _a.children, rest = __rest(_a, ["collectionView", "className", "children"]);
    var type = collectionView === null || collectionView === void 0 ? void 0 : collectionView.type;
    if (!(collectionView === null || collectionView === void 0 ? void 0 : collectionView.type))
        return null;
    var name = collectionView.name || "".concat(type[0].toUpperCase()).concat(type.slice(1));
    return (React.createElement("div", __assign({ className: cs('notion-collection-view-type', className) }, rest),
        React.createElement(CollectionViewIcon, { className: 'notion-collection-view-type-icon', type: type }),
        React.createElement("span", { className: 'notion-collection-view-type-title' }, name),
        children));
};
function generateCollectionHeader(collectionView) {
    var _a, _b;
    var name = (collectionView === null || collectionView === void 0 ? void 0 : collectionView.name) || (collectionView === null || collectionView === void 0 ? void 0 : collectionView.type) || '';
    var icon = (_a = collectionView.format.collection_view_icon) !== null && _a !== void 0 ? _a : '';
    var host = 'https://notion.so';
    name = ((_b = name[0]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) + (name === null || name === void 0 ? void 0 : name.slice(1)) || '';
    switch (collectionView === null || collectionView === void 0 ? void 0 : collectionView.type) {
        case 'board':
            icon = (React.createElement(SvgCollectionViewBoard, { className: 'notion-collection-header-1-svg' }));
            break;
        case 'timeline':
            icon = (React.createElement(SvgCollectionViewTimeline, { className: 'notion-collection-header-1-svg' }));
            break;
        case 'calendar':
            icon = (React.createElement(SvgCollectionViewCalendar, { className: 'notion-collection-header-1-svg' }));
            break;
        case 'gallery':
            icon = (React.createElement(SvgCollectionViewGallery, { className: 'notion-collection-header-1-svg' }));
            break;
        case 'list':
            if (icon !== '') {
                icon = (React.createElement("img", { src: host + icon, className: 'notion-collection-header-1-svg', alt: '' }));
            }
            else {
                icon = (React.createElement(SvgCollectionViewList, { className: 'notion-collection-header-1-svg' }));
            }
            break;
        default:
            icon = (React.createElement(SvgCollectionViewTable, { className: 'notion-collection-header-1-svg' }));
    }
    return {
        name: name,
        icon: icon
    };
}
//# sourceMappingURL=collection.js.map